export function isLinux() {
  return navigator.platform.indexOf('Linux') > -1;
}
